import { DatePipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'eta',
})
export class EtaPipe implements PipeTransform {
  constructor(private datePipe: DatePipe) {}

  public transform(milliseconds: number): any {
    if (!milliseconds) {
      milliseconds = 0;
    }
    return this.datePipe.transform(new Date(new Date().getTime() + milliseconds * 60000), 'shortTime');
  }
}
